var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoHighLevelWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 869 869",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-493 -61)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 434.5,
    cy: 434.5,
    r: 434.5,
    transform: "translate(493 61)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(617.184 224.258)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 80.606,
    height: 430.93,
    transform: "translate(91.97 109.538)",
    fill: "#B6B6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M18.4,26.659l80.606,76.473V26.659Z",
    transform: "translate(73.569 106.573)",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M132.276,0,0,138.472H264.9Z",
    transform: "translate(0 0)",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 92.32,
    height: 236.28,
    transform: "translate(263.686 304.188)",
    fill: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M51.936,65.609l96.453,83.334V65.609Z",
    transform: "translate(207.619 262.276)",
    fill: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M36.02,177.426,168.3,38.949l132.62,138.478Z",
    transform: "translate(143.992 155.702)",
    fill: "#A0A0A0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 80.606,
    height: 430.925,
    transform: "translate(447.656 109.608)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M89.575,26.672l80.606,76.473V26.672Z",
    transform: "translate(358.083 106.625)",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M71.172,138.49h264.9L203.448.012Z",
    transform: "translate(284.514 0.051)",
    fill: "#707070"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoHighLevelWhite);
export default __webpack_public_path__ + "static/media/GoHighLevelWhite.599d38b409b375b47ac26d88b93bacb7.svg";
export { ForwardRef as ReactComponent };